module.exports = __webpack_public_path__ + "img/ic_twitter.d9769dbb.png";